export class BillingTypedWithSourceModel {
    month: string = "";
    source: string = ""
    type: string = "";
    total: string|number = 0;

    constructor(b?:Partial<BillingTypedWithSourceModel>) {
        Object.assign(this, b)   

        if (!((this.total as any) instanceof Number)) {
            this.total = this.total ? Number(this.total) : 0
        }
    }
}

